/* global jQuery */

import GA4Tracking from './utils/ga4-tracking'

export const addPurchaseOnPageLoad = () => {
  const gaPurchaseElement = jQuery('[data-ga-p]')
  if (gaPurchaseElement.length === 0) {
    return
  }

  let gaData = gaPurchaseElement.attr('data-ga-p')
  gaData = JSON.parse(gaData)
  if (typeof gaData !== 'object') {
    return
  }

  GA4Tracking.pushEvent(
    'purchase',
    gaData.items,
    {
      transaction_id: gaData.transaction_id,
      tax: gaData.tax,
      shipping: gaData.shipping
    }
  )
}
